import React from 'react';
import styled from 'styled-components';
import {accountType} from '../../../../../../../util/utils';
import EllipsesControl from '../../../../../EllipsesControl/EllipsesControl';

export default function AccountTypeCellRenderer(params) {
	const accountLabel = accountType?.find((ac) => ac.id === params.value)?.accounttypename ?? '-';

	return (
		<StyledAccountTypeCellRenderer className="StyledAccountTypeCellRenderer">
			<EllipsesControl content={accountLabel} tooltip={accountLabel} noOfLines={1} />
		</StyledAccountTypeCellRenderer>
	);
}
const StyledAccountTypeCellRenderer = styled.section`
	display: flex;
	font-size: var(--px-14);
	font-weight: 300;
`;
